import { Drawer, Button } from "antd";
import { InvoiceFilterConstants } from "./constants";
import {
  DrawerHeaderStyle,
  GhostButtonStyles,
} from "../../../../constants/CustomStyles";
import styles from "./FilterDrawer.module.scss";
import FilterForm from "./FilterForm";
import TNButton from "../../../../reusable-components/TNButton";
import {
  ButtonShape,
  ButtonSize,
  ButtonType,
} from "../../../../enums/ButtonAttributesEnums";
import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { filterFieldConstants } from "./FilterForm/constants";

interface InvoiceFilterProps {
  isOpen: boolean;
  closeDrawer: () => void;
  handleSetFilter: () => void;
  currentFilter: object;
  handleSetDateRange: React.Dispatch<React.SetStateAction<{}>>;
  clearAllFilterButton: boolean;
  handleDisableClearAllFilterButton: () => void;
  handleClearAllFilter: () => void;
}

const FilterDrawer = (props: InvoiceFilterProps) => {
  const {
    isOpen,
    closeDrawer,
    handleSetFilter,
    currentFilter,
    handleSetDateRange,
    clearAllFilterButton,
    handleDisableClearAllFilterButton,
    handleClearAllFilter,
  } = props;
  const { getValues, setValue } = useFormContext();
  const [values, setValues] = useState({});
  const [clickableOrder, addClickableOrder] = useState([]);
  const [tempClickableOrder, addTempClickableOrder] = useState([]);

  const {
    DRAWER: {
      MASK,
      MASK_CLOSABLE,
      DESTROY_ON_CLOSE,
      CLOSABLE,
      GET_CONTAINER,
      PLACEMENT,
      WIDTH,
      HEIGHT,
      SIZE,
      TITLE,
    },
    FOOTER: { CANCEL_BUTTON_LABEL, APPLY_BUTTON_LABEL, CLEAR_BUTTON_LABEL },
  } = InvoiceFilterConstants;

  const handleCancel = () => {
    setValues({ ...currentFilter });
    addTempClickableOrder(clickableOrder);
    closeDrawer();
  };

  const handleApply = () => {
    const dates = getValues(filterFieldConstants.FILTER_DATE_RANGE_FILTER_NAME);
    if (!dates || dates?.length === 0) {
      handleSetDateRange?.({
        startDate: undefined,
        endDate: undefined,
      });
    } else {
      handleSetDateRange?.({ startDate: dates?.[0], endDate: dates?.[1] });
    }
    handleSetFilter({ ...values });
    addClickableOrder(tempClickableOrder);
    closeDrawer();
  };
  const drawerFooter = (
    <div className={styles.FooterContainer}>
      <div>
        <TNButton
          shape={ButtonShape.ROUND}
          size={ButtonSize.LARGE}
          text={CLEAR_BUTTON_LABEL}
          ghost
          danger
          onClick={() => {
            handleClearAllFilter();
            closeDrawer();
          }}
        />
      </div>
      <div className={styles.RightCTA}>
        <TNButton
          shape={ButtonShape.DEFAULT}
          size={ButtonSize.LARGE}
          type={ButtonType.DEFAULT}
          onClick={handleCancel}
          text={CANCEL_BUTTON_LABEL}
        />
        <TNButton
          shape={ButtonShape.DEFAULT}
          size={ButtonSize.LARGE}
          type={ButtonType.PRIMARY}
          onClick={handleApply}
          text={APPLY_BUTTON_LABEL}
        />
      </div>
    </div>
  );

  useEffect(() => {
    if (!clearAllFilterButton) return;
    setValues({});
    addTempClickableOrder([]);
    addClickableOrder([]);
    handleDisableClearAllFilterButton();
  }, [clearAllFilterButton]);

  useEffect(() => {
    setValues(currentFilter);
  }, [currentFilter]);

  return (
    <Drawer
      visible={isOpen}
      onClose={handleCancel}
      className={styles.InvoiceDrawer}
      maskClosable={MASK_CLOSABLE}
      mask={MASK}
      destroyOnClose={DESTROY_ON_CLOSE}
      closable={CLOSABLE}
      getContainer={GET_CONTAINER}
      placement={PLACEMENT}
      width={WIDTH}
      height={HEIGHT}
      size={SIZE}
      title={TITLE}
      headerStyle={DrawerHeaderStyle}
      footer={drawerFooter}
    >
      <FilterForm
        values={values}
        setValues={setValues}
        clickableOrder={tempClickableOrder}
        addClickableOrder={addTempClickableOrder}
      />
    </Drawer>
  );
};
export default FilterDrawer;
